import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import useFlatsGridState from '../hooks/useFlatsGridState';
import useHousingStockState from '../hooks/useHousingStockState';
import { useMemo } from 'react';

const deleteTenant = async (bindId) => {
  return await request.delete(
    `/HousingStock/bind_client/${bindId}`,
    {},
    'При удалении жильца произошла ошибка',
    'Error'
  );
};
const useDeleteTenant = () => {
  const queryClient = useQueryClient();

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const queryKeys = useMemo(
    () => [flatsGridQueryKey, housingStockQueryKey],
    [flatsGridQueryKey, housingStockQueryKey]
  );

  return useMutation(deleteTenant, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryKeys.forEach((key) => queryClient.invalidateQueries(key));
    },
  });
};

export default useDeleteTenant;
